import dayjs from "dayjs";
import { DATE_FORMAT } from "localConstants.ts";
import React from "react";

interface DateCellProps {
    value?: string | Date | null;
}

export const DateCell: React.FC<DateCellProps> = ({ value }) => {
    if (!value) return <>–</>;
    return <>{dayjs(value).format(DATE_FORMAT)}</>;
};
